export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1'

export const REFRESH_INTERVALS = {
  DASHBOARD: 30 * 1000,
  NODES: 15 * 1000,
  ALERTS: 60 * 1000,
} as const

export const STALE_TIMES = {
  DEFAULT: 30 * 1000,
  STATS: 5 * 60 * 1000,
} as const

export const NODE_STATUS_COLORS = {
  Active: 'bg-success text-success-foreground',
  Pending: 'bg-warning text-warning-foreground',
  Blocked: 'bg-destructive text-destructive-foreground',
  Rotating: 'bg-primary text-primary-foreground',
  Offline: 'bg-muted text-muted-foreground',
} as const

export const SEVERITY_COLORS = {
  critical: 'bg-destructive text-destructive-foreground',
  warning: 'bg-warning text-warning-foreground',
  info: 'bg-secondary text-secondary-foreground',
} as const
